import script from "./Login.vue?vue&type=script&lang=ts&setup=true"
export * from "./Login.vue?vue&type=script&lang=ts&setup=true"

import "./Login.vue?vue&type=style&index=0&id=3dc40c36&lang=scss"

const __exports__ = script;

export default __exports__